module.exports = __webpack_public_path__ + "img/format.cd552ff9.svg";